<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Valoare energetică</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">1850 / 441 kJ/kcal</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">285 / 68 kJ/kcal</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "valoare",

  data() {
    return {
      active: true
    }
  }
}
</script>

<style>

</style>
